import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'SourceSansPro, sans-serif',
    body1: {
      color: '#54565A',
    },
    body2: {
      color: '#54565A',
      fontSize: '0.9em',
    },
    h1: {
      fontFamily: 'Lora, sans-serif',
      color: '#009845',
      fontSize: '2.25em',
      fontWeight: 'bold',
    },
    h2: {
      fontSize: '1.1em',
      textTransform: 'uppercase',
      fontWeight: 'bold',
    },
    h3: {
      fontSize: '0.9em',
      // textTransform: 'uppercase',
      fontWeight: 'bold',
      color: '#009845',
    },
  },
  palette: {
    green: {
      main: '#009845',
      contrastText: '#fff',
    },
    gray: {
      main: '#54565A',
    },
    wine: {
      main: '#870064',
    },
    tanzanite: {
      main: '#1C355e',
    },
    turquoise: {
      main: '#006580',
    },
    aquamarine: {
      main: '#10cfc9',
    },
    aquamarineDark: {
      main: '#00A5A0',
    },
  },
  components: {
    MuiList: {
      styleOverrides: {
        root: {
          padding: '0 !important',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#009845',
            color: 'white',
          },
          '&.Mui-selected:focus': {
            backgroundColor: '#009845',
            color: 'white',
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#009845 !important',
            color: 'white !important',
          },
          '&:hover': {
            backgroundColor: '#f5fbff !important',
            color: '#54565A !important',
          },
          '&.Mui-focused': {
            backgroundColor: 'transparent !important',
          },
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
        },
      },
    },

      MuiCssBaseline: {
        styleOverrides: {
          body: {
            margin: 0,
            padding: 0,
            width: '100%',
          },
          html: {
            margin: 0,
            padding: 0,
            width: '100%',
          },
        //   'div[data-key="tooltip"]': {
        //     zIndex: '999999',
        //   },
        //   'svg[data-key="legend"]': {
        //     left: '0 !important',
        //     width: '100% !important',
        //   },
        //   'button[data-component-key="legend"]': {
        //     display: 'none',
        //   },
        //   '.fp-slidesNav': {
        //     display: 'flex',
        //     justifyContent: 'center',
        //   },
        //   '.fp-slidesNav.fp-bottom': {
        //     bottom: '0',
        //     '@media (max-width:600px)': {
        //       bottom: 'calc(50% - 31.8px)',
        //       background: '#EEEEEF',
        //     },
        //   },
        //   '#fp-nav.fp-right': {
        //     right: 0,
        //   },
        //   '.fp-tooltip': {
        //     background: '#333333cc',
        //     color: '#fff',
        //     padding: 4,
        //     borderRadius: 4,
        //     '@media (max-width:600px)': {
        //       display: 'none !important',
        //     },
        //   },
        //   '@media (max-width:600px)': {
        //     '#slopeViz div[data-key="tooltip"]': {
        //       display: 'none !important',
        //     },
        //     '.pic-tooltip': {
        //       width: 'auto !important',
        //       transform: 'translate(-50%, -50%) !important',
        //       right: 'auto !important',
        //       top: '50% !important',
        //       left: '50% !important',
        //     },
        //     '.pic-tooltip-arrow': {
        //       display: 'none',
        //     },
        //     '#fp-nav ul li:hover a span, .fp-slidesNav ul li:hover a span': {
        //       width: '4px',
        //       height: '4px',
        //       margin: '-2px 0 0 -2px',
        //     },

        // },
        // '#fp-nav ul li .fp-tooltip.fp-right': {
        //   maxWidth: 'fit-content !important',
        // },
        // '#fp-nav ul li .fp-tooltip': {
        //   top: '-6px',
        // },
      },
    },
  },
});

export default theme;
